import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link",
  "use": "link-usage",
  "viewBox": "0 0 384 448",
  "content": "<symbol viewBox=\"0 0 384 448\" id=\"link\"><path d=\"M320 232V112c0-8.75-7.25-16-16-16H184c-6.5 0-12.25 4-14.75 9.75-2.5 6-1.25 13 3.5 17.5l36 36-133.5 133.5a15.844 15.844 0 0 0 0 22.5l25.5 25.5a15.844 15.844 0 0 0 22.5 0l133.5-133.5 36 36c3 3.25 7 4.75 11.25 4.75 2 0 4.25-.5 6.25-1.25C316 244.25 320 238.5 320 232zm64-128v240c0 39.75-32.25 72-72 72H72c-39.75 0-72-32.25-72-72V104c0-39.75 32.25-72 72-72h240c39.75 0 72 32.25 72 72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/link.svg
// module id = sAHT
// module chunks = 1